import React from 'react';
import { getLabel } from '../InitData';
import { FavoritesContext } from './FavoritesContextProvider';
import { getConfiguration } from '../data/utils';

function FavouritesSelection(props) {
	const favoriteContext = React.useContext(FavoritesContext)
    
	function handleClick() {
		favoriteContext.setShowFavourites(true);
	}

	const selected = props.selected ? ' icona-selezionata' : '';
	//const icoFavourites = iconSportCssClass(props.id, props.iconClass);
    const icoFavourites = 'icoFavourites';
	const conf = getConfiguration();

	return (
      <div className={"icona-slider-sport icona-preferiti " + selected} style={{order: props.order}} onClick={handleClick}>


	  {conf.iwh ? 
	    <figure className="sport-icona-live sport-icona-live-wh">
               
			    <div className={`img-fluid ico-sport ${icoFavourites}`}>
                </div>
			    <span>{getLabel('general.preferiti')}</span>
				{props.counter != null &&
    			    <span className="contatore-live-icone">({props.counter})</span>
                }
		    </figure>
	  
	  
	  :
	  <figure className="sport-icona-live">
                {props.counter != null &&
    			    <span className="contatore-live-icone">{props.counter}</span>
                }
			    <div className={`img-fluid ico-sport ${icoFavourites}`}>
                </div>
			    <span>{getLabel('general.preferiti')}</span>
		    </figure>}
		   
	    </div>
    );
}

export default FavouritesSelection;